// --------------------------------------------------------
// USER LIST ITEM - UserListItem
// --------------------------------------------------------
import { useEffect, useState } from 'react'
import { ReactComponent as Avatar } from '../../assets/imgs/avatar.svg'
import { ListItemContainer, Table, TableData, Text, TextLink } from '../UI/generalLayout/Layout.styled'
import { useAppDispatch } from '../..'
import { useNavigate } from 'react-router-dom';
import { Paths } from '../../enums/Paths'
import { ItemInfoContainer, MobileContainer, ViewEditContainer } from '../companyListItem/CompanyListItemMobile.styled'
import { Auth } from '../../core/http/service/Auth'
import useResponsiveInfo from '../../hooks/useResponsiveInfo'
import Colors from '../../constants/Colors'
import CustomDropdown from '../dropdown/CustomDropdown'
import GenericModal from '../genericModal/GenericModal'
import * as userRoleActions from '../../store/actions/userRole';

// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------

// --------------------------------------------------------
// USER LIST ITEM INTERFACE
// --------------------------------------------------------

interface IUserListItem {
    item: any;
    roles: any[];
}
/**
 * A component that renders a User List Item.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const UserListItem = ({item, roles}: IUserListItem) => {
    // --------------------------------------------------------
    // USER LIST ITEM PRIVATE DECLARATIONS
    // --------------------------------------------------------    
    const [userRoles, setUserRoles] = useState<string[]>(item?.getRolesDescriptionList())
    const [userRolesBackup, setUserRolesBackup] = useState<string[]>(item?.getRolesDescriptionList())
    const [showModalAssignRole, setShowModalAssignRole] = useState(false)
    const [showModalResetarSenha, setShowModalResetarSenha] = useState(false);
    const [showModalSuccess, setShowModalSuccess] = useState(false);
    const [showModalError, setShowModalError] = useState(false);    
    const [cpfRedefinirSenha, setCpfRedefinirSenha] = useState("");    
    const [titleError, setTitleError] = useState("");
    const { isMobile } = useResponsiveInfo()
    const dispatch = useAppDispatch()
    const navigate = useNavigate();

    useEffect(()=>{
        setUserRoles(item?.getRolesDescriptionList())
    }, [item])

    // --------------------------------------------------------
    const addUserRole = (value: string[])=>{
        setUserRoles(value)
    }

    const onClickAssignRoleButton = ()=>{
        if(userRoles.length === 0){
            alert('Selecione ao menos um perfil para o usuário')
        }else{
            setShowModalAssignRole(true)
        }
    }

    const assignRolesToUser = async ()=>{
        await dispatch(userRoleActions.assignRolesToUser(item.id, userRoles))
        setUserRolesBackup(userRoles)
        setShowModalAssignRole(false) 
    }

    const onCancelRoleAssignment = ()=>{
        setUserRoles(userRolesBackup)
        setShowModalAssignRole(false)
    }

    
    const onConfirmResetPassword = async ()=>{
        
        try {

            if(item && item?.solicitacaoRedefinirSenha){
                setTitleError("Ocorreu um erro ao solicitar a redefinição de senha. Já houve uma solicitação anterior, use o CPF como senha.")
                setShowModalResetarSenha(false);
                setShowModalError(true);
                return;
            }else{
                setShowModalError(false);
            }

            //RESETAR SENHA    
            if (cpfRedefinirSenha) {
                const service = new Auth();
                service.RedefinePassword({ User: cpfRedefinirSenha })
                    .then(result => {

                        const data = result.data as any;
            
                        if (data.success) {
                            
                            console.log("Password reset successful.");                            
                            setShowModalResetarSenha(false);
                            setShowModalSuccess(true);
                        } else {
                            setShowModalResetarSenha(false)
                            setTitleError('Ocorreu um erro ao solicitar a redefinição de senha. Já houve uma solicitação anterior, use o CPF como senha.');
                            console.error("Password reset failed:", data.errors[0]);
                            setShowModalError(true);
                        }

                    })
                    .catch(error => {     
                        setTitleError('Erro ao atualizar os dados! Por favor tente mais tarde ou entre em contato com o suporte.');                   
                        console.error("Erro na chamada:", error);  
                        setShowModalError(true);
                    });
            } else {
                setCpfRedefinirSenha("");
            }
            
        } catch (error) {
            console.log(error)
        }

    }

    const onEditPerson = async (personId: string, cpf: string)=>{
        
        try {                 
            navigate(Paths.UserRoleEditProfile, { state: { personId, cpf } });            
        } catch (error) {
            console.log(error)
        }

    }

    const getRoleChangeModalString = ()=>{
        let msg = 'Tem certeza que deseja alterar o(s) perfil(s) de ' + item.pessoa.nome + ' para: ';
        userRoles.forEach((role: any, index: number)=>{
            msg = msg + role + (index === userRoles.length - 1? '' : ', ')
        })

        return msg
    }

    const maskCPF = (value: string) => {
        return value
          .replace(/\D/g, '')
          .replace(/(\d{3})(\d)/, '$1.$2')
          .replace(/(\d{3})(\d)/, '$1.$2') 
          .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
      };
    // --------------------------------------------------------
    // REACT RETURN FUNCTION
    // --------------------------------------------------------
    return (
        <>
        {/* UserListItemTable */}
            <ListItemContainer>
                {!isMobile? (
                <Table>
                    <TableData width={'5%'} style={{ verticalAlign:'middle' }}>
                        <Avatar color={Colors.SPM500} /> {/** Avatar aqui caso não tenha foto */}
                    </TableData>
                    <TableData width={'25%'}>
                       <Text bold style={{ margin: 0 }}>{item.pessoa.nome}</Text>{/** Nome */}
                       {item.pessoa.isDependente && (
                           <Text style={{ fontSize: 12, color: Colors.SPM500, margin: 0, marginTop: 2 }}>
                               Dependente
                           </Text>
                       )}
                    </TableData>
                    <TableData width={'20%'}>
                        <Text>{maskCPF(item.pessoa.cpf)}</Text> {/** CPF c/ máscara */}
                    </TableData>
                    <TableData width={'20%'}>
                        <Text>{item.empresa.nomeFantasia}</Text> {/** Empresa */}
                    </TableData>

                    <TableData width={'10%'}>                                                                    
                        <TextLink 
                            style={{ fontWeight: 'bold'}}
                            color={Colors.SPM500}                
                            onClick={() => onEditPerson(item.pessoa.id, item.pessoa.cpf)}
                            >
                                EDITAR
                        </TextLink>                                 
                    </TableData>  
                    
                    <TableData width={'15%'}>                          
                        <TextLink 
                            style={{ fontWeight: 'bold'}}
                            color={Colors.SPM500}                
                            onClick={() => {
                                setShowModalResetarSenha(true) 
                                setCpfRedefinirSenha(item.pessoa.cpf.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5'))
                            }}                            
                            >
                                REDEFINIR SENHA
                        </TextLink>                                               
                    </TableData> 

                    <TableData  width={'15%'} style={{ verticalAlign: 'middle' }}>
                        <CustomDropdown 
                            value={userRoles} 
                            onChange={addUserRole}
                            assignRole={onClickAssignRoleButton}
                            bottomButtonMsg="Atribuir função"
                            containerStyle={{ width: 230 }} 
                            items={roles} 
                            disabled={false} 
                            multiple={true} 
                            backgroundColor={Colors.SPM500} 
                            textColor={'white'} 
                        />              
                    </TableData>
                   

                </Table>):
                (                    
                    <MobileContainer>
                        <ItemInfoContainer>
                            <Text bold color={Colors.GRAY900} style={{ margin: 0 }}>{item.pessoa.nome}</Text>
                            {item.pessoa.isDependente && (
                                <Text style={{ fontSize: 12, color: Colors.SPM500, margin: 0, marginTop: 2 }}>
                                    Dependente
                                </Text>
                            )}
                            <Text 
                                color={true? '#8D8D8D':Colors.GRAY400} 
                                style={{ fontSize: 14, marginTop: -6 }}
                            >
                               {maskCPF(item.pessoa.cpf)}
                            </Text>
                            <Text 
                                color={true? '#8D8D8D':Colors.GRAY400} 
                                style={{ fontSize: 14, marginTop: -6 }}
                            >
                               {item.empresa.nomeFantasia}
                            </Text>                            
                            
                            <ViewEditContainer  style={{width: 200}}>
                                <TextLink 
                                    bold 
                                    color={Colors.SPM500} 
                                    style={{ fontSize: 12 }} 
                                    onClick={() => onEditPerson(item.pessoa.id, item.pessoa.cpf)}>
                                    EDITAR
                                </TextLink>
                                <TextLink 
                                    bold 
                                    color={Colors.SPM500} 
                                    style={{ fontSize: 12 }} 
                                    onClick={() => setShowModalResetarSenha(true)}>
                                    REDEFINIR SENHA
                                </TextLink>
                                
                            </ViewEditContainer>
                            <br/>
                            <div style={{ alignItems:'center', width: 280}}>
                                <CustomDropdown 
                                    value={userRoles} 
                                    onChange={addUserRole}
                                    assignRole={onClickAssignRoleButton}
                                    bottomButtonMsg="Atribuir função"
                                    containerStyle={{ width: '95%', marginRight: 16, marginLeft: 12 }} 
                                    items={roles} 
                                    disabled={false} 
                                    multiple={true} 
                                    backgroundColor={Colors.SPM500} 
                                    textColor={'white'} 
                                />   
                            </div> 
                        </ItemInfoContainer>                        
                    </MobileContainer>                    
                )
            }
            </ListItemContainer>

            <GenericModal
                modalTitle={'Confirmar alteração de perfil'} 
                modalSubtitle={getRoleChangeModalString()} 
                cancelButtonMsg={'Cancelar'} 
                confirmButtonMsg={'Alterar'}
                visible={showModalAssignRole}
                onCancel={assignRolesToUser}
                onConfirm={onCancelRoleAssignment}
            />    

            <GenericModal                 
                visible={showModalResetarSenha} 
                onCancel={onConfirmResetPassword } 
                onConfirm={ () => setShowModalResetarSenha(false)} 
                modalTitle={'Você tem certeza de que deseja redefinir a senha deste usuário? A nova senha será o mesmo que o CPF cadastrado.'} 
                modalSubtitle={''} 
                cancelButtonMsg={'Voltar'} 
                confirmButtonMsg={'Redefinir'}                
            />   

            <GenericModal                 
                visible={showModalSuccess} 
                onCancel={() => setShowModalSuccess(false)} 
                onConfirm={() => setShowModalSuccess(false)} 
                modalTitle={'Sucesso, senha foi redefinida com sucesso! A nova senha será o mesmo que o CPF cadastrado.'} 
                modalSubtitle={''} 
                cancelButtonMsg={''} 
                confirmButtonMsg={'Ok'}                
            />    

            <GenericModal                 
                visible={showModalError} 
                onCancel={() => setShowModalError(false)} 
                onConfirm={() => setShowModalError(false)} 
                modalTitle={titleError} 
                modalSubtitle={''} 
                cancelButtonMsg={''} 
                confirmButtonMsg={'Ok'}                
            />           

        </>
    )
    // --------------------------------------------------------
}

export default UserListItem